import { IntlShape } from 'react-intl';

export const dictionary = {
    selection_load_more: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.SelectionPage.f6b5f35f6564a567f1810df0b730e3dc',
            defaultMessage: 'Load more',
            description: 'Подпись кнопки загрузки списка на странице подборки для скринридера',
        }),

    selection_empty_watch_later: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.selection.f54e51a715b45a3889a8470673361b12',
            defaultMessage:
                'Movies and TV series you added to "Watch later" will appear in this selection',
            description: 'Заголовок для пустой подборки WatchLater',
        }),
    selection_empty_watch_later_button: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.EmptySelectionContent.watch_later.7b19b37e7fc3dfe3c3e1ad5b84c7f565',
            defaultMessage: 'Home page',
            description: 'Кнопка для пустой подборки WatchLater',
        }),
};
